import { isApiError } from '@dorixona/api'
import { Icon } from './Icon'

/** Данные ещё идут. Не скелет, а строка: раздел появляется целиком. */
export function Loading({ what }: { what: string }) {
  return (
    <div className="adm-loading" role="status">
      Загружаем {what}…
    </div>
  )
}

/**
 * Текст отказа. Ветвимся по коду ошибки, а не по её сообщению: сообщение
 * сервер пишет для журнала, а не для экрана (docs/frontend/README.md › Errors).
 */
export function failureText(error: unknown): string {
  if (!isApiError(error)) return 'Не удалось связаться с сервером. Проверьте соединение.'
  if (error.code === 'forbidden') return 'Роль не открывает эти данные.'
  if (error.code === 'not_found') return 'Данные не найдены — возможно, их удалили.'
  if (error.status >= 500) return `Сервер не ответил. Запрос ${error.requestId || 'без номера'}.`
  return 'Запрос не прошёл. Попробуйте ещё раз.'
}

export interface FailedProps {
  what: string
  error: unknown
  onRetry: () => void
}

/**
 * Запрос не прошёл: что именно не загрузилось, почему и кнопка «ещё раз».
 * Строка-предупреждение кита, а не отдельная карточка: она встаёт и в
 * карточку, и в таблицу, и на место всего экрана.
 */
export function Failed({ what, error, onRetry }: FailedProps) {
  return (
    <div className="ui-alert ui-failed" data-tone="danger" data-layout="row" role="alert">
      <Icon name="i-alert" />
      <div className="txt">
        <b>Не удалось загрузить {what}</b> {failureText(error)}
      </div>
      <button
        type="button"
        className="ui-btn"
        data-variant="secondary"
        data-size="sm"
        onClick={onRetry}
      >
        Повторить
      </button>
    </div>
  )
}
